import { render, staticRenderFns } from "./AlertDefault.vue?vue&type=template&id=60b180a0&"
import script from "./AlertDefault.vue?vue&type=script&lang=js&"
export * from "./AlertDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports